import ProductSellingPriceProvider from './hooks/useProductSellingPrice';

import { ProductSellingPriceProps } from './@types/ProductSellingPriceProps';

const ProductSellingPrice = (props: ProductSellingPriceProps) => (
	<ProductSellingPriceProvider {...props}>
		<span
			data-selection={props.componentId}
			className={`sellingPrice sellingPrice--${props.blockClass} vtex-product-price-1-x-sellingPrice vtex-product-price-1-x-sellingPrice--${props.blockClass} vtex-product-price-1-x-sellingPrice--hasListPrice vtex-product-price-1-x-sellingPrice--${props.blockClass}--hasListPrice`}
		>
			<span
				className={`sellingPriceValue sellingPriceValue--${props.blockClass} vtex-product-price-1-x-sellingPriceValue vtex-product-price-1-x-sellingPriceValue--${props.blockClass}`}
			>
				<span
					className={`currencyContainer currencyContainer--${props.blockClass} vtex-product-price-1-x-currencyContainer vtex-product-price-1-x-currencyContainer--${props.blockClass}`}
				>
					<span
						className={`currencyCode currencyCode--${props.blockClass} vtex-product-price-1-x-currencyCode vtex-product-price-1-x-currencyCode--${props.blockClass}`}
					>
						R$
					</span>
					<span
						className={`currencyLiteral currencyLiteral--${props.blockClass} vtex-product-price-1-x-currencyLiteral vtex-product-price-1-x-currencyLiteral--${props.blockClass}`}
					>
						&nbsp;
					</span>
					<span
						className={`currencyInteger currencyInteger--${props.blockClass} vtex-product-price-1-x-currencyInteger vtex-product-price-1-x-currencyInteger--${props.blockClass}`}
					>
						10
					</span>
					<span
						className={`currencyDecimal currencyDecimal--${props.blockClass} vtex-product-price-1-x-currencyDecimal vtex-product-price-1-x-currencyDecimal--${props.blockClass}`}
					>
						,
					</span>
					<span
						className={`currencyFraction currencyFraction--${props.blockClass} vtex-product-price-1-x-currencyFraction vtex-product-price-1-x-currencyFraction--${props.blockClass}`}
					>
						00
					</span>
				</span>
			</span>
		</span>
	</ProductSellingPriceProvider>
);

export default ProductSellingPrice;
